var React = require('react');

function UsersLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 25a9.5 9.5 0 119.5-9.5A9.52 9.52 0 0115 25zm0-17a7.5 7.5 0 107.5 7.5A7.51 7.51 0 0015 8zm14 34H1a1 1 0 01-1-1 15 15 0 0130 0 1 1 0 01-1 1zM2 40h25.96a13 13 0 00-25.92 0H2zm45 2H33a1 1 0 110-2h13a10 10 0 00-14.58-7.92.999.999 0 01-1.41-1.188 1 1 0 01.49-.582 12 12 0 0117.51 10.66A1.002 1.002 0 0147 42zM35.89 28a7.5 7.5 0 117.5-7.5 7.51 7.51 0 01-7.5 7.5zm0-13a5.5 5.5 0 100 11 5.5 5.5 0 000-11z"}));
}

UsersLight.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = UsersLight;

UsersLight.default = UsersLight;
